import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonSection } from './components/ComparisonSection';
import { MoreTestimonialsSection } from './components/MoreTestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostComparisonSection } from './components/CostComparisonSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const script = document.createElement('script');
      script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','2032586933980278');fbq('track','PageView');`;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2032586933980278&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen bg-black text-gray-200" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <StatsBar data-id="element-3" />
        <TestimonialsSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SystemSection data-id="element-6" />
        <HowItWorksSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ComparisonSection data-id="element-10" />
        <MoreTestimonialsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <CostComparisonSection data-id="element-14" />
        <ClosingSection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <WhatsAppButton data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}